import React, {useEffect} from 'react';

import Layout from 'antd/lib/layout';

import Header from '../layout/header/index';
import Footer from '../layout/footer/index';
import Main from '../layout/main/index';
import * as appActions from './actions';

import './css/custom.scss';
import {useDispatch} from 'react-redux';

const App: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(appActions.fetchAppSettings());
    }, [dispatch]);

    return (
        <div className="volunteer">
            <Layout>
                <Header />
                <Main />
                <Footer />
            </Layout>
        </div>
    );
};

export default App;
